import type { ValueOrCondition } from '@unifyapps/defs/types/conditionalValueFilters';
import type { LCColorValue } from '@unifyapps/defs/types/styleObject';
import type { CSSProperties } from 'react';
import tinycolor from 'tinycolor2';
import { getConditionalPropertyValue } from '../../../utils/conditionalValues';

// Token-based colors resolve to Tailwind class names (e.g. `text-primary`).
// Variable bindings or mapped values can arrive as raw CSS color literals —
// hex, rgb/rgba, hsl/hsla, hwb, oklch/oklab, lab/lch, or named colors.
// tinycolor validates against all of those and rejects tailwind-class strings
// and unresolved templates. `var(--token)` is also a valid raw CSS value but
// tinycolor doesn't recognise it, so we allow it explicitly.
const isRawCssColor = (value: string) => value.startsWith('var(') || tinycolor(value).isValid();

export const getColorClassNameAndStyle = (
  color: ValueOrCondition<LCColorValue> | undefined,
  property: keyof CSSProperties,
) => {
  const computedColor = getConditionalPropertyValue<LCColorValue>({
    value: color,
  });

  if (typeof computedColor === 'object') {
    return { style: { [property]: computedColor.custom } as CSSProperties };
  }

  if (typeof computedColor === 'string' && isRawCssColor(computedColor)) {
    return { style: { [property]: computedColor } as CSSProperties };
  }

  return { className: computedColor };
};
